export const slugify = (name) =>
  (name || "").trim().toLowerCase().replace(/\s+/g, "-");

export const validateSubject = ({ name, order }) => {
  const errors = {};
  if (!(name || "").trim()) errors.name = "Name is required";
  if (!Number.isInteger(order) || order < 1)
    errors.order = "Order must be a whole number, 1 or more";
  return errors;
};

// D6: a rename strands every tutor whose doc carries the old name string.
export const canMutateName = (tutorCount) => tutorCount === 0;
